import { LeftCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Col, Descriptions, Row } from "antd";
import { useGetDealerMappingQuery } from "../../redux/services/dealerMappingApi";
import { useNavigate, useParams } from "react-router-dom";

const ViewDealerMapping = (props: any) => {
  const params = useParams();
  const navigate = useNavigate();

  const dealerMappingId = params?.dealerMappingId;

  const { data, error, isLoading } = useGetDealerMappingQuery(dealerMappingId);
  const dealer_mapping = data?.third_party_dealer_mapping;

  const onGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      {!isLoading && dealer_mapping && (
        <>
          <Row style={{ marginBottom: 20 }}>
            <Col
              sm={24}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <h2>Dealer Mapping Details</h2>
              <Button onClick={onGoBack} size="middle" type="default" icon={<LeftCircleOutlined />}>
                Back
              </Button>
            </Col>
          </Row>
          <Descriptions
            title=""
            bordered
            column={1}
            labelStyle={{ fontWeight: 700, width: 300 }}
            size="middle"
          >
            <Descriptions.Item label="Brand Name">
              {dealer_mapping.brand?.name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Dealer Name">
              {dealer_mapping.dealer_name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Dealer Code">
              {dealer_mapping.dealer_code || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Branch Name">
              {dealer_mapping.branch_name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Branch Code">
              {dealer_mapping.branch_code || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Branch Address">
              {dealer_mapping.branch_address || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Branch City">
              {dealer_mapping.branch_city?.name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Branch State">
              {dealer_mapping.branch_state?.name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Branch Pincode">
              {dealer_mapping.branch_pin_code || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Dealer Branch Code">
              {dealer_mapping.dealer_branch_code || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Assigned City Manager">
              {dealer_mapping.assigned_city_manager?.name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Status">
              <span style={{ textTransform: "capitalize" }}>
                {dealer_mapping.status || "-"}
              </span>
            </Descriptions.Item>
          </Descriptions>
        </>
      )}
      {isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
          }}
        >
          <LoadingOutlined style={{ fontSize: 24 }} spin />
        </div>
      )}
    </>
  );
};

export default ViewDealerMapping;
